import React from 'react';

import Dialog from './Dialog';
import Button from './Button';

function AlertDialog({title, description, ok = 'OK', onOk, extraButtons}) {
  return (
    <Dialog
      title={title}
      description={description}
      buttons={
        <>
            <Button autoFocus onClick={onOk}>{ok}</Button>
            {extraButtons && extraButtons}
        </>
      }
    />
  );
}

export default AlertDialog;